module.exports = __webpack_public_path__ + "cerulean_seamstress.webp?5edd38018753f132029f88e422b60e2c";


//////////////////
// WEBPACK FOOTER
// ./public/creator-avatar/cerulean_seamstress.webp
// module id = 224
// module chunks = 0